import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';

import { BrandThemesEnum, PositionEnum, SdSpyTargetDirective } from '@seb/web-design-system/core';

import { BaseComparatorComponent } from '../../../components/base/base-comparator/base-comparator.component';
import { ProductComparatorComponentInterface } from '../../../models';
import { AbstractComponent } from '../abstract-component.component';
import { WrapperComponent } from '../../../components/static/core';

@Component({
  selector: 'wc-product-comparator',
  templateUrl: './product-comparator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    WrapperComponent,
    BaseComparatorComponent,
    SdSpyTargetDirective
  ]
})
export class ProductComparatorComponent extends AbstractComponent<ProductComparatorComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  productCodes: string[];
  titleThemesConfig = BrandThemesEnum.brand;
  textConfig = PositionEnum.center;
  readonly context = 'Product Comparator';

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  override mandatoryFunction = (cmp: ProductComparatorComponentInterface): boolean => {
    return !!cmp.products;
  };

  ngOnInit(): void {
    this.subscriptions.add(
      this.component$.subscribe((cmp: ProductComparatorComponentInterface) => {
        this.productCodes = cmp.products?.split(' ');
        this.cdRef.markForCheck();
      })
    );
  }

  hasLoaded(): void {
    this.setLoaded();
    this.cdRef.markForCheck();
  }
}
